import { useModalContext } from "@/context/ModalContext";
import styles from "./GetPlusButton.module.css";
import ConversionModal from "../ConversionModal/ConversionModal";
import { Mixpanel } from "@/helpers/mixpanel";
import { useRouter } from "next/router";
import { useAuth } from "@/context/AuthContext";

export default function GetPlusButton(props: {
  source: string;
  trait?: boolean;
}) {
  const { setModalComponent } = useModalContext();
  const { user } = useAuth();

  const router = useRouter();
  return (
    <button
      onClick={() => {
        setModalComponent(
          <ConversionModal initialSlide={props.source === "Trait" ? 1 : 0} />
        );
        Mixpanel?.track(
          "Premium Conversion Modal Summoned",
          {
            source: props.source,
            trait_slug:
              props.source === "Trait" ? router.query.traitSlug : undefined,
          },
          user?.uid
        );
      }}
      className={styles.button}
    >
      Get Plus
    </button>
  );
}
